import './App.css';
import VideoPlayer from "./VideoPlayer";
import Login from "./Login";
import {useState} from "react";

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('isAuthenticated') === 'true'
    });

    const handleLoginSuccess = () => {
        setIsAuthenticated(true);
        localStorage.setItem('isAuthenticated', 'true');
    };
  return (
    <div className="App">
        {isAuthenticated ? (
            <VideoPlayer />
        ) : (
            <Login onLoginSuccess={handleLoginSuccess} />
        )}
    </div>
  );
}

export default App;
